<template>
  <div class="Manager">
    <div class="breadcrumb">
      <span style="font-size: 14px">管理员账号管理</span>
      <el-button class="right_f" type="primary" @click="addManager(2)"
        >新增学校管理员</el-button
      >
      <el-button class="right_f" type="primary" @click="addManager(4)"
        >新增场馆管理员</el-button
      >
      <!-- <el-button class="right_f" type="primary" @click="addManager(5)">新增班级管理员</el-button> -->
    </div>

    <div class="selectSchool">
      <el-select
        class="selectInput"
        v-model="region"
        filterable
        clearable
        placeholder="请输入高校名称"
        :loading="loading"
        @change="seletedschool"
      >
        <el-option
          v-for="item in option"
          :key="item.firstLetter"
          :label="item.name"
          :value="item.rootUnid"
        >
        </el-option>
      </el-select>

      <el-select v-model="roleType" class="roleType" @change="seletedschool">
        <el-option label="全部身份" value="0"></el-option>
        <el-option label="学校管理员" value="2"></el-option>
        <el-option label="场馆管理员" value="4"></el-option>
        <el-option label="班级管理员" value="5"></el-option>
      </el-select>
    </div>

    <div class="com-list">
      <el-table :data="managerData" style="width: 100%">
        <el-table-column type="index" prop="index" label="序号" width="80">
        </el-table-column>
        <el-table-column prop="campusName" label="高校名称" width="200">
        </el-table-column>
        <el-table-column prop="username" label="账号" width="200">
        </el-table-column>
        <el-table-column label="身份" width="200" inline-template>
          <div>
            <span v-if="row.roleType == 2">学校管理员</span>
            <span v-if="row.roleType == 4">场馆管理员</span>
            <span v-if="row.roleType == 5">班级管理员</span>
          </div>
        </el-table-column>
        <el-table-column inline-template label="操作">
          <span>
            <el-button
              type="text"
              size="small"
              @click="editClass(row)"
              v-if="row.roleType == 5"
              >编辑班级
            </el-button>
            <el-button type="text" size="small" @click="editManager(row)"
              >修改密码</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="deleteManager($index, row)"
              >删除</el-button
            >
          </span>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :title="title"
      v-model="addFormVisible"
      :modal-append-to-body="false"
    >
      <el-form :model="addForm" :rules="addRules" ref="addForm">
        <el-form-item label="账号" prop="name" :label-width="formLabelWidth">
          <el-input
            type="text"
            v-model="addForm.name"
            auto-complete="off"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="昵称"
          prop="showname"
          :label-width="formLabelWidth"
        >
          <el-input
            type="text"
            v-model="addForm.showname"
            auto-complete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="密码" prop="pass" :label-width="formLabelWidth">
          <el-input
            type="password"
            v-model="addForm.pass"
            auto-complete="off"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="确认密码"
          prop="repass"
          :label-width="formLabelWidth"
        >
          <el-input
            type="password"
            v-model="addForm.repass"
            auto-complete="off"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item label="行政班级" required v-if="addType == 5" :label-width="formLabelWidth">
					<el-checkbox-group v-model="addForm.depart">
						<el-checkbox v-for="item in departs" :label="item.id" value="item.cid" :key='item.cid'>{{item.department}}</el-checkbox>
					</el-checkbox-group>
				</el-form-item> -->

        <el-form-item
          label="行政班级:"
          v-if="addType == 5"
          :label-width="formLabelWidth"
        >
          <el-checkbox-group v-model="isCheckAll" @change="checkAll">
            <el-checkbox label="true">全选</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          label=""
          prop="depart"
          v-if="addType == 5"
          :label-width="formLabelWidth"
        >
          <el-checkbox-group v-model="addForm.depart">
            <el-checkbox
              v-for="item in departs"
              :label="item.id"
              value="item.id"
              :key="item.id"
            >
              {{ item.department }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="addNewManager"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="修改密码"
      v-model="editFormVisible"
      :modal-append-to-body="false"
    >
      <el-form :model="editForm" :rules="editRules" ref="editForm">
        <el-form-item label="账号" prop="name" :label-width="formLabelWidth">
          <el-input
            type="text"
            v-model="editForm.name"
            :disabled="true"
            auto-complete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="密码" prop="pass" :label-width="formLabelWidth">
          <el-input
            type="password"
            v-model="editForm.pass"
            auto-complete="off"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="确认密码"
          prop="repass"
          :label-width="formLabelWidth"
        >
          <el-input
            type="password"
            v-model="editForm.repass"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editPass">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    let checkName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账户名称"));
      } else {
        if (value.length > 20) {
          callback(new Error("长度在8-20个字符之间"));
        } else {
          if (/^[a-zA-z0-9\u4E00-\u9FA5]*$/.test(value) === false) {
            callback(new Error("不能输入空格和特殊字符"));
          } else {
            callback();
          }
        }
      }
    };
    let validatePass1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("密码不能为空"));
      } else {
        if (value.length > 20) {
          callback(new Error("长度在8-20个字符之间"));
        } else if (/^[a-zA-z0-9\u4E00-\u9FA5]*$/.test(value) === false) {
          callback(new Error("不能输入空格和特殊字符"));
        } else {
          if (this.addForm.repass !== "") {
            this.$refs.addForm.validateField("repass");
          }
          callback();
        }
      }
    };
    let validateRePass1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请确认密码"));
      } else if (value !== this.addForm.pass) {
        callback(new Error("密码不一致，请重新输入"));
      } else {
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("密码不能为空"));
      } else {
        if (value.length > 20) {
          callback(new Error("长度在8-20个字符之间"));
        } else if (/^[a-zA-z0-9\u4E00-\u9FA5]*$/.test(value) === false) {
          callback(new Error("不能输入空格和特殊字符"));
        } else {
          if (this.editForm.repass !== "") {
            this.$refs.editForm.validateField("repass");
          }
          callback();
        }
      }
    };
    let validateRePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请确认密码"));
      } else if (value !== this.editForm.pass) {
        callback(new Error("密码不一致，请重新输入"));
      } else {
        callback();
      }
    };
    return {
      region: this.$util.getUrlParam("rootUnid") || "",
      roleType: this.$util.getUrlParam("roleType") || "0",
      title: "新增学校管理员账号",
      addType: "",
      editType: "",
      managerData: [],
      departs: [],
      option: [],
      list: [],
      loading: false,
      schoolLists: [],
      isCheckAll: false,
      addFormVisible: false,
      addForm: {
        index: "",
        name: "",
        pass: "",
        repass: "",
        showname: "",
        depart: [],
      },
      addRules: {
        name: [
          { required: true, message: "请输入账号名称", trigger: "blur" },
          { validator: checkName },
        ],
        showname: [
          { required: true, message: "请输入账号昵称", trigger: "blur" },
          { validator: checkName },
        ],
        pass: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass1 },
        ],
        repass: [
          { required: true, message: "请确认密码", trigger: "blur" },
          { validator: validateRePass1 },
        ],
      },
      editFormVisible: false,
      editForm: {
        index: "",
        name: "",
        pass: "",
        repass: "",
      },
      editRules: {
        pass: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass2 },
        ],
        repass: [
          { required: true, message: "请确认密码", trigger: "blur" },
          { validator: validateRePass2 },
        ],
      },
      formLabelWidth: "120px",
    };
  },
  mounted() {
    //获取所有高校管理员
    this.getallschool();
    if (this.$util.getUrlParam("rootUnid")) {
      this.seletedschool();
    }
  },
  methods: {
    //获取高校名称
    getallschool() {
      this.$http({
        method: "get",
        url: this.$util.domain + "/adminapi/v1/basicTools/allSchools",
      }).then((response) => {
        if (response.data.error == 10000) {
          this.option = response.data.data;
        } else {
          this.$util.errorMsg(response.data.message);
        }
      });
    },

    //选择一个学校
    seletedschool() {
      this.$http({
        method: "get",
        url: `${this.$util.domain}/adminapi/v1/campus/schoolAdmin/query?rootUnid=${this.region}&roleType=${this.roleType}`,
      }).then((response) => {
        this.managerData = [];
        if (response.data.error == 10000) {
          let dataList = response.data.data;
          dataList.forEach((item) => {
            this.managerData.push(item);
          });
        } else {
          this.$util.errorMsg(response.data.message);
        }
      });
    },
    addManager(type) {
      if (this.region == 0 || this.region == "") {
        this.$util.errorMsg("请选择一个有效高校");
        return false;
      } else {
        switch (type) {
          case 2:
            this.title = "新增学校管理员账号";
            break;
          case 4:
            this.title = "新增场馆管理员账号";
            break;
          default:
            this.title = "新增班级管理员账号";
            break;
        }

        if (type == 5) {
          this.getAllDepart();
        }
        this.addType = type;
        this.addFormVisible = true;
        if (this.$refs.addForm) {
          this.$refs.addForm.resetFields();
        }
      }
    },
    //全选与取消全选
    checkAll(val) {
      this.addForm.depart = val ? this.departs.map((item) => item.id) : [];
    },
    //增加新校区确定按钮点击
    addNewManager() {
      //this.addForm.name;//用户名
      //this.addForm.pass;//密码
      //this.addForm.repass;//确认密码

      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let url =
            this.$util.domain + "/adminapi/v1/campus/schoolAdmin/addOrEdit";
          let requestParams = {
            rootUnid: this.region,
            username: this.addForm.name,
            password: this.addForm.pass,
            showName: this.addForm.showname, //昵称
            actionType: 1,
            roleType: this.addType * 1,
          };

          if (this.addType == 5) {
            url =
              this.$util.domain +
              "/adminapi/v1/campus/schoolAdmin/v2/addOrEdit";
            let newArr = this.addForm.depart.map((item) => item * 1);
            requestParams.departmentIds = newArr;
          }

          this.$http({
            url,
            method: "POST",
            body: JSON.stringify(requestParams),
          }).then((response) => {
            this.addFormVisible = false;
            if (response.data.error == 10000) {
              this.$util.successMsg("添加成功");
              this.seletedschool();
            } else {
              this.$util.errorMsg(response.data.message);
            }
          });
        }
      });
    },
    //修改管理员
    editManager(row) {
      this.editFormVisible = true;
      this.editForm.name = row.username;
      this.editType = row.roleType;
    },
    editPass() {
      this.$refs.editForm.validate((valid) => {
        //发送请求
        let url =
          this.$util.domain +
          (this.editType == 5
            ? "/adminapi/v1/campus/schoolAdmin/v2/addOrEdit"
            : "/adminapi/v1/campus/schoolAdmin/addOrEdit");
        this.$http({
          url,
          method: "POST",
          body: JSON.stringify({
            rootUnid: this.region,
            username: this.editForm.name,
            password: this.editForm.pass,
            actionType: 2, //新增或者修改1，新增，2，修改
            roleType: this.editType * 1,
          }),
        }).then((response) => {
          if (response.data.error == 10000) {
            this.$util.successMsg("修改密码成功");
            this.editFormVisible = false;
          } else {
            this.$util.errorMsg(response.data.message);
          }
        });
      });
    },
    //删除管理员
    deleteManager($index, row) {
      this.$http({
        method: "get",
        url: this.$util.domain + "/adminapi/v1/campus/schoolAdmin/delete",
        params: {
          rootUnid: row.rootUnid,
          username: row.username,
          roleType: row.roleType,
        },
      }).then((response) => {
        if (response.data.error == 10000) {
          this.$util.successMsg("删除成功");
          this.managerData.splice($index, $index + 1);
          this.editFormVisible = false;
        } else {
          this.$util.errorMsg(response.data.message);
        }
      });
    },
    //获取某个学校下面所有院系
    getAllDepart() {
      let url =
        this.$util.domain + "/adminapi/v1/campus/schoolAdmin/v2/getDepartments";

      this.$http({
        url,
        method: "GET",
        params: {
          rootUnid: this.region,
        },
      }).then((response) => {
        this.departs = [];
        if (response.data.error == 10000) {
          let list = response.data.data;
          list.forEach((item) => {
            this.departs.push({
              id: item.id + "",
              department: item.department,
            });
          });
        }
      });
    },
    //跳转至编辑班级
    editClass(row) {
      let params = {
        rootUnid: this.region,
        username: row.username,
      };
      this.$util.refreshTo("/#/xiaoyuan/GX/editClass", params);
    },
  },
};
</script>

<style>
.roleType {
  margin-top: 10px;
  width: 250px;
}
</style>



// WEBPACK FOOTER //
// Manager.vue?bc9b255e